import {Observable} from 'rxjs';
import i18next from 'i18next';

import {combineEpics} from 'web-app/util/redux-observable';
import * as GlobalEventActions from 'web-app/react/global-event/actions';

import * as Api from './api';
import * as Actions from './actions';

const fetchNotificationSettings = action$ =>
    action$.ofType(Actions.fetchNotificationSettings.type).mergeMap(() =>
        Api.fetchNotificationSettings()
            .map(notificationSettings => Actions.fetchNotificationSettingsSuccess.action({notificationSettings}))
            .catch(e => Observable.of(Actions.fetchNotificationSettingsFailed.action(e))),
    );

const updateNotificationSettings = action$ =>
    action$.ofType(Actions.updateNotificationSettings.type).mergeMap(({payload}) =>
        Api.updateNotificationSettings(payload.notificationSettings)
            .flatMap(notificationSettings => [
                Actions.updateNotificationSettingsSuccess.action({notificationSettings}),
                GlobalEventActions.updateSuccess.action(i18next.t('account.settingsUpdated')),
            ])
            .catch(e => Observable.of(Actions.updateNotificationSettingsFailed.action(e))),
    );

export default combineEpics(fetchNotificationSettings, updateNotificationSettings);
